import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { AmountUtils, DateUtils } from '@shared/utils';
import type { GetCardAccountBalanceReportResponse } from '@shared/api/rest/accounts';
import { Table, TableCellType } from '@shared/widgets';

interface IAccountTableProps {
  isLoading?: boolean;
  accounts: GetCardAccountBalanceReportResponse[];
  currentPage: number;
  totalItemCount: number;
  countItemPage: number;
  onChangePage: (pageNumber: number) => void;
  onChangeCountItemPage: (pageNumber: number) => void;
}
export const AccountTable = (props: IAccountTableProps) => {
  const { t } = useTranslation('reports');

  const columns = useMemo(
    () => [
      t('card.account.columns.date'),
      t('card.account.columns.accountLabel'),
      t('card.account.columns.currency'),
      t('card.account.columns.availableBalance'),
    ],
    [t],
  );
  return (
    <Table
      isLoading={props.isLoading}
      isScrollable
      columns={columns}
      items={props.accounts.map((x) => [
        { type: TableCellType.Text, value: DateUtils.formatDate(x.dateCreated) },
        { type: TableCellType.Text, value: x.accountLabel ? x.accountLabel : x.accountName.replaceAll('X', '*') },
        { type: TableCellType.Text, value: x.currency.toUpperCase() },
        { type: TableCellType.Text, value: AmountUtils.transformToAmountWithCurrency(x.availableBalance, x.currency) },
      ])}
      pagination={{
        currentPage: props.currentPage,
        totalItemCount: props.totalItemCount,
        countItemPage: props.countItemPage,
        onChangePage: props.onChangePage,
        onChangeCountItemPage: props.onChangeCountItemPage,
      }}
    />
  );
};
